import { render, staticRenderFns } from "./controlGoodsDetailList.vue?vue&type=template&id=1da257c4&scoped=true"
import script from "./controlGoodsDetailList.vue?vue&type=script&lang=js"
export * from "./controlGoodsDetailList.vue?vue&type=script&lang=js"
import style0 from "./controlGoodsDetailList.vue?vue&type=style&index=0&id=1da257c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da257c4",
  null
  
)

export default component.exports